import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, OnInit, inject, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { IncludesPipe } from '@zero/shared/ui-pipes';
import { ButtonComponent, IconComponent, PillComponent } from '@zero/shared/ui-web-design-system';
import { TagType, TagsFacade } from '@zero/tags/domain';
import { AllTagsActivePipe } from '../../pipes/all-tags-active/all-tags-active.pipe';

@Component({
  selector: 'tags-dropdown',
  templateUrl: './tags-dropdown.component.html',
  styleUrls: ['./tags-dropdown.component.scss'],
  imports: [
    TranslocoPipe,
    AsyncPipe,
    IconComponent,
    NgbDropdownModule,
    IncludesPipe,
    AllTagsActivePipe,
    PillComponent,
    UpperCasePipe,
    ButtonComponent,
  ],
})
export class TagsDropdownComponent implements OnInit {
  public readonly facade = inject(TagsFacade);
  public type = input.required<TagType>();

  ngOnInit(): void {
    this.facade.loadTags(this.type());
  }
}
